import App from "@/App";
import "@/index.css";
// import "@/styles/tablet.css";
import "@/i18n"; // Initialize i18n
import PageLoading from "@components/Loading";
import store from "@redux/store";
import { registerBusinessErrorGuard } from "@services/businessErrorGuard";
import "@services/mock";
import VersionService from "@services/version";
import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

// The axios interceptor rejects 2xx failure envelopes (isSuccess:false) with a BusinessError
// that it has already surfaced as a toast. Register a guard so those rejections don't also log
// as "Unhandled promise rejection" on the many .then()-only call sites. Real errors still surface.
registerBusinessErrorGuard();

// Reaching this point means the app bundle loaded successfully, so clear the one-shot
// chunk-reload guard (set in ErrorBoundary) — a later stale-chunk error in this tab session
// should be allowed to auto-reload again.
try {
  sessionStorage.removeItem("chunkReloadAttempted");
} catch {
  // sessionStorage unavailable — nothing to clear.
}

const root = document.getElementById("root");
root
  ? createRoot(root).render(
      // <StrictMode>
      <Suspense fallback={<PageLoading />}>
        <Provider store={store}>
          <App />
        </Provider>
      </Suspense>,
      // </StrictMode>,
    )
  : console.error("Root element not found. Make sure you have a div with id 'root' in your HTML.");

// Initialize version control system immediately
console.log("🔍 NODE_ENV:", process.env.NODE_ENV);
const versionService = VersionService.getInstance();

// Register service worker for PWA functionality
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/service-worker.js");
      console.log("✅ Service Worker registered successfully:", registration.scope);

      // Initialize version control system after service worker is ready
      await versionService.initialize();
      console.log("✅ Version control system initialized (production mode)");
    } catch (error) {
      console.error("❌ Service Worker registration failed:", error);
    }
  });
} else {
  // Initialize version service in development mode for testing
  console.log("🚀 Initializing version service in development mode...");
  versionService
    .initialize()
    .then(() => {
      console.log("✅ Version control system initialized (development mode)");
    })
    .catch(error => {
      console.error("❌ Version control system initialization failed:", error);
    });
}
